/**
 * Identity of the published word. Must not include solve state or the revealed
 * answer — those change for the same word and would end polling too early.
 */
export function wordFingerprint(data) {
  if (!data) return '';
  if (data.dailyWordId) return `id:${data.dailyWordId}`;
  return `letters:${data.shuffledLetters || ''}`;
}

/**
 * After the countdown ends, poll until the server reports a different word.
 * Resolves with { data, changed } — data is the last payload seen (or null).
 */
export async function pollForNewWord({
  fetchToday,
  previousFingerprint,
  sleep,
  isCancelled = () => false,
  maxAttempts = 40,
  intervalMs = 3000
}) {
  let last = null;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (isCancelled()) return { data: last, changed: false };
    const data = await fetchToday();
    if (isCancelled()) return { data: last, changed: false };
    // A failed fetch (null) is retried — one network blip shouldn't end the poll.
    if (data) {
      last = data;
      if (wordFingerprint(data) !== previousFingerprint) {
        return { data, changed: true };
      }
    }
    if (attempt < maxAttempts - 1) {
      await sleep(intervalMs);
    }
  }
  return { data: last, changed: false };
}
